<template>
  <div style="width: 100%;height: 100%">
    <!-- 订单Title -->
    <V-DSOrderDetailTitleData :title-data="data[0]"></V-DSOrderDetailTitleData>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="名称" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="GYS_PRICE" label="采购价"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税采购价"></el-table-column>
          <el-table-column prop="PROJECT_SALE_PRICE" label="销售价"></el-table-column>
          <el-table-column prop="PROJECT_SALE_PRICE_BEFORE_TAX" label="不含税销售价">
            <template slot-scope="scope">
              <span>{{ Number(scope.row.PROJECT_SALE_PRICE_BEFORE_TAX).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="采购总金额"></el-table-column>
          <el-table-column prop="PRODUCT_FEE_BEFORE_TAX" label="不含税采购总金额"></el-table-column>
          <el-table-column prop="销售总金额" label="销售总金额"></el-table-column>
          <el-table-column prop="不含税销售总金额" label="不含税销售总金额"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" v-if="this.当前供应链公司ID != 6245">
            <template slot-scope="scope">
              <!-- <el-button v-show="fun_dic[1110501]" @click="openEdit(scope.row)" type="text">修改</el-button> -->
              <el-button size="small" type="text" @click="editProduct(scope.row)" icon="el-icon-edit"
                v-if="userPriceType == 1">修改</el-button>
              <el-button size="small" type="text" @click="editProductSpecial(scope.row)" icon="el-icon-edit" v-else>修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 修改弹出框 -->
    <el-row>
      <el-col>
        <el-dialog title="修改" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
          <el-radio-group v-model="radio" style="display: block; text-align: center; margin-bottom: 30px;">
            <el-radio label="1">按总额修改</el-radio>
            <el-radio label="2">按数量修改</el-radio>
          </el-radio-group>
          <el-form size="small" :model="editForm" ref="editForm" label-width="120px">
            <el-form-item label="产品名称：">
              <span>{{ this.editForm.PRODUCT_NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.editForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="实收数量：">
              <el-input v-model="editForm.REAL_COUNT" @change="RealCount" @input="countFee"
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="单价：">
              <el-input v-model="editForm.GYS_PRICE" @change="GysPrice" @input="countFee" disabled
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="不含税单价：">
              <el-input v-model="editForm.BEFORE_TAX_PRICE" disabled></el-input>
            </el-form-item>
            <el-form-item label="总金额：">
              <el-input v-model="editForm.TOTAL_FEE" @change="TotalFee" @input="changePrice" disabled
                oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="不含税总金额：">
              <el-input v-model="editForm.PRODUCT_FEE_BEFORE_TAX" disabled></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
              <el-input v-model="editForm.PRODUCT_COMMENT" maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="修改数量类型：">
              <el-radio-group v-model="editForm.typeRadio">
                <el-radio label="0">修改实收数量</el-radio>
                <el-radio label="1">修改产品数量和实收数量</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="editFormVisible = false">取 消</el-button>
            <el-button size="small" @click="editSubmit">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="修改" center :visible.sync="specialEditFormVisible" width="600px" :close-on-click-modal="false">
          <el-form :model="specialEditForm" ref="specialEditForm" size="small" :rules="rules"
            :label-width="formLabelWidth">
            <el-form-item label="产品名称：">
              <span>{{ this.specialEditForm.PRODUCT_NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.specialEditForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="采购价：" prop="REAL_PRICE">
              <label slot="label">采&nbsp;&nbsp;购&nbsp;&nbsp;价：</label>
              <el-input v-model="specialEditForm.REAL_PRICE" @input="specialEditRealPriceInput"></el-input>
            </el-form-item>
            <el-form-item label="不含税采购价：" prop="BEFORE_TAX_PRICE">
              <el-input v-model="specialEditForm.BEFORE_TAX_PRICE" disabled></el-input>
            </el-form-item>
            <el-form-item label="销售价：" prop="销售价" v-show="fun_dic[1110502]">
              <label slot="label">销&nbsp;&nbsp;售&nbsp;&nbsp;价：</label>
              <el-input v-model="specialEditForm.销售价" @change="修改销售价()"></el-input>
            </el-form-item>
            <el-form-item label="实收数量：" prop="REAL_COUNT">
              <el-input v-model="specialEditForm.REAL_COUNT"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="specialEditFormVisible = false">取 消</el-button>
            <el-button size="small" @click="submitEdit('specialEditForm')" :loading="loading1">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { newDSOrderDetailFun } from '@/assets/api/DSOrder';
import { frontEndFun } from '@/assets/api/frontFun';
import { modifyOrderFun } from '@/assets/api/shopOrderManage';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import VDSOrderDetailTitleData from '../DSOrder/DSOrderDetailTitleData';
import validation from '@/assets/common/validation';

export default {
  data () {
    return {
      当前供应链公司ID: sessionStorage.getItem('tcId'),
      fromName: ['DSHistoryOrderList'],
      toName: [],
      PAGE_ID: '11105', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1110501: 0, 1110502: 0 }, // 功能ID 一旦规定不要轻易改动
      managername: sessionStorage.getItem('name'),
      tcName: sessionStorage.getItem('tcName'),
      tableData: [],
      name: '',
      data: [
        {
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      printStatus: '',
      // formLabelWidth: '100px',
      // editFormVisible: false,
      // editForm: {},
      companyID: Number(sessionStorage.getItem('company_id')),
      ORDER_ID: sessionStorage.getItem('orderId'),
      ORDER_DETAIL_ID: '',
      // rules: {
      //   PROJECT_PRICE: [
      //     { required: true, message: '请输入单价', trigger: 'blur' },
      //   ],
      //   REAL_COUNT: [
      //     { required: true, message: '请输入实收数量', trigger: 'blur' },
      //   ],
      // },
      loading1: false,
      editFormVisible: false,
      radio: '1',
      editForm: {
        PRODUCT_NAME: '',
        TYPE_UNIT: '',
        REAL_COUNT: '',
        GYS_PRICE: '',
        BEFORE_TAX_PRICE: '',
        TOTAL_FEE: '',
        PRODUCT_FEE_BEFORE_TAX: '',
        PRODUCT_COMMENT: '',
        typeRadio: '',
      },
      specialEditFormVisible: false,
      specialEditForm: {},
      rules: {
        REAL_PRICE: [
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
        REAL_COUNT: [
          { required: true, message: '请输入实收数量', trigger: 'blur' },
        ],
      },
      formLabelWidth: '150px',
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
    };
  },
  components: {
    VDSOrderDetailTitleData,
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // --------------------------------查看订单详情
    queryOrderDetailListData () {
      const params = {
        ID: Number(this.ORDER_ID),
      };
      newDSOrderDetailFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list.map((item) => ({
            ...item,
            PRODUCT_CODE: item.PRODUCT_CODE.toString(),
            销售总金额: (Number((item.PROJECT_SALE_PRICE * item.REAL_COUNT).toFixed(3))).toFixed(2),
            不含税销售总金额: (Number((item.PROJECT_SALE_PRICE_BEFORE_TAX * item.REAL_COUNT).toFixed(3))).toFixed(2),
          }));
          const {
            ORDER_ID, SEND_DATE, CUSTOMER_NAME, PROJECT_NAME, DK_NAME,
          } = JSON.parse(sessionStorage.getItem('DSOrderDetailTitle'));
          this.data = result.length > 0 ? result[0].title.map((item) => ({
            ...item,
            ORDER_ID,
            ORDER_CODE: item.ORDER_CODE,
            SEND_DATE,
            TOTAL_FEE: item.REAL_TOTAL_GYS_FEE,
            SUPPLIER_NAME: item.SUPPLIER_NAME,
            CUSTOMER_NAME,
            PROJECT_NAME,
            DK_NAME,
          })) : [];
          this.printStatus = result[0].modify_flag;
          // ---------------------------------------获取判断的companyID
          this.companyID = result[0].title[0].TC_ID;
        } else {
          this.tableData = [];
          this.printStatus = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit (row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    close () {
      this.editFormVisible = false;
    },
    editProduct (row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.data[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.editFormVisible = true;
      this.editForm = { ...row };
    },
    editSubmit () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!validation.价格正数0验证(this.editForm.GYS_PRICE)) {
            this.$message.show({ text: '请输入正确的价格', type: 'warning' });
            return;
          }
          const params = {
            SERVICE_ID: '10003',
            OTYPE: 40,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRODUCT_CODE: Number(this.editForm.PRODUCT_CODE),
            ORDER_ID: this.ORDER_ID,
            ORDER_DETAIL_ID: this.editForm.ID,
            NEW_COUNT: Number(this.editForm.REAL_COUNT),
            PRICE: this.editForm.GYS_PRICE,
            PRODUCT_FEE: Number(this.editForm.TOTAL_FEE),
            BEFORE_TAX_PRICE: Number(this.editForm.BEFORE_TAX_PRICE),
            TAX_RATE: Number(this.editForm.TAX_RATE),
            // PRODUCT_COUNT: this.editForm.PRODUCT_COUNT,
            // MODIFY_REAL_FLAG: 1,
          };
          if (this.editForm.PRODUCT_COMMENT) {
            params.PRODUCT_COMMENT = this.editForm.PRODUCT_COMMENT;
          }
          if (this.editForm.typeRadio) {
            params.MODIFY_REAL_FLAG = Number(this.editForm.typeRadio);
          }

          // if (!this.editForm.PRODUCT_COUNT || !this.editForm.REAL_COUNT) {
          //   this.$message.show({ text: '请输入订购数量和实收数量', type: 'warning' });
          //   return false;
          // }
          // this.loading = true

          for (const key in params) {
            if ([null, undefined, Infinity, NaN].includes(params[key])) {
              this.$message.show({ text: '请输入正确的数', type: 'warning' });
              return false;
            }
          }

          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.queryOrderDetailListData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    RealCount (e) {
      this.editForm.REAL_COUNT = e;
    },
    GysPrice (e) {
      this.editForm.GYS_PRICE = e;
    },
    TotalFee (e) {
      this.editForm.TOTAL_FEE = e;
    },
    countFee () {
      if (Number(this.radio) === 1) {
        this.editForm.GYS_PRICE = (Math.round((this.editForm.TOTAL_FEE / this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.NEW_BEFORE_TAX_PRICE = Number(((this.editForm.TOTAL_FEE / (1 + this.editForm.TAX_RATE / 100)) / this.editForm.REAL_COUNT).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
      } else if (Number(this.radio) === 2) {
        this.editForm.NEW_BEFORE_TAX_PRICE = Number((this.editForm.GYS_PRICE / (1 + this.editForm.TAX_RATE / 100)).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
        this.editForm.TOTAL_FEE = (Math.round((this.editForm.GYS_PRICE * this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.PRODUCT_FEE_BEFORE_TAX = (Math.round((Number(this.editForm.GYS_PRICE * this.editForm.REAL_COUNT) / (1 + this.editForm.TAX_RATE / 100)) * 100) / 100).toFixed(2);
      }
    },
    changePrice () {
      if (Number(this.radio) === 1) {
        this.editForm.GYS_PRICE = (Math.round((this.editForm.TOTAL_FEE / this.editForm.REAL_COUNT) * 100) / 100).toFixed(2);
        this.editForm.PRODUCT_FEE_BEFORE_TAX = (Math.round((Number(this.editForm.TOTAL_FEE) / (1 + this.editForm.TAX_RATE / 100)) * 100) / 100).toFixed(2);
        this.editForm.NEW_BEFORE_TAX_PRICE = Number(((this.editForm.TOTAL_FEE / (1 + this.editForm.TAX_RATE / 100)) / this.editForm.REAL_COUNT).toFixed(10));
        this.editForm.BEFORE_TAX_PRICE = this.editForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
      }
    },
    editProductSpecial (row) {
      // 关账限制
      if (this.$util.isOrderClosed(this.data[0].SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      this.specialEditFormVisible = true;
      this.specialEditForm = { ...row, 销售价: row.PROJECT_SALE_PRICE };
    },
    specialEditRealPriceInput (val) {
      val = val.replace(/[^0-9]*/, '');
      this.specialEditForm.NEW_BEFORE_TAX_PRICE = Number((val / (1 + this.specialEditForm.TAX_RATE / 100)).toFixed(10));
      this.specialEditForm.BEFORE_TAX_PRICE = this.specialEditForm.NEW_BEFORE_TAX_PRICE.toFixed(2);
    },
    submitEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.specialEditForm.REAL_COUNT)) {
            this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
            return false;
          }
          if (!util.JudgmentUnit(this.specialEditForm.TYPE_UNIT)) { // 如果不是
            const beInter = (this.specialEditForm.REAL_COUNT % 1 === 0);
            if (beInter == false) {
              this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
              return false;
            }
          }
          if (!validation.价格正数验证(this.specialEditForm.REAL_PRICE)) {
            this.$message.show({ text: '请输入单价', type: 'warning' });
            return false;
          }
          if (!validation.价格正数验证(this.specialEditForm.销售价)) {
            this.$message.show({ text: '请输入正确的销售价', type: 'warning' });
            return false;
          }
          const updateParams = {
            ORDER_DETAIL_ID: Number(this.specialEditForm.ID),
            ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_COUNT: Number(this.specialEditForm.REAL_COUNT),
            PRICE: this.specialEditForm.REAL_PRICE,
            PRODUCT_COMMENT: this.specialEditForm.PRODUCT_COMMENT,
            PRICE_MODE: this.userPriceType,
            BEFORE_TAX_PRICE: this.specialEditForm.NEW_BEFORE_TAX_PRICE || this.specialEditForm.BEFORE_TAX_PRICE,
            TAX_RATE: this.specialEditForm.TAX_RATE,
            SALE_DETAIL_ID: this.specialEditForm.SALE_DETAIL_ID,
            PROJECT_SALE_PRICE: this.specialEditForm.销售价,
          };
          this.loading1 = true;
          modifyOrderFun(updateParams).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.loading1 = false;
            this.editPriceFormVisible = false;
            this.specialEditFormVisible = false;
            this.queryOrderDetailListData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading1 = false;
          });
        } else {
          return false;
        }
      });
    },
    修改销售价 (val) {
      if (!validation.价格正数验证(this.specialEditForm.销售价)) {
        this.$message.show({ text: '请输入正确的销售价', type: 'warning' });
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从历史订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryBeforeFun();
        that.queryOrderDetailListData();
      }
    });
  },
};
</script>
<style scoped>
.ma img {
  width: 105px
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSHistoryDetail.vue